import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import t from '../../lib/I18n';
import Page from '../general/Page';

function StepHeader({ number, label, active, className, isVisibleStepNumber = true }) {
    const classes = classnames(
        'step-header', className, 'text-weight--normal',
        {
            'step-header--active': active
        }
    );
    return (
        <Page title={label}>
            <h2 className={classes}>
                {isVisibleStepNumber ? (
                    <span className="step-header__number">
                        <span className="sr-only">{t('global.step')} </span>
                        {number}
                        <span className="sr-only">. </span>
                    </span>
                ) : null}
                <legend className="step-header__legend">{label}</legend>
            </h2>
        </Page >
    );
}

StepHeader.propTypes = {
    number: PropTypes.number,
    label: PropTypes.string,
    active: PropTypes.bool,
    className: PropTypes.string,
    isVisibleStepNumber: PropTypes.bool
};

StepHeader.defaultProps = {
    number: 0,
    label: '',
    active: false,
    className: '',
    isVisibleStepNumber: true
};

export default StepHeader;
